exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".raw_logo {\n  height: 305;\n  width: 440;\n}\n", ""]);

